import { AfterLoadEventHandler, CreateOptionsParams, ISpecializedCombo, useCombo } from "@hooks/useCombo"
import { IEnumRecord } from "@hooks/useRequest"
import { MenuItem } from "@material-ui/core"
import { useVendedorComissaoService } from "@services/VendedorComissaoService"
import { useThemeColor } from "@themes/Colors"
import { KeyOfEnum } from "@utils/TypeHelpers"
import React from "react"
import { IContratoCliente } from "./ContratoCliente"
import { EnumEmpresa, IEmpresa } from "./Empresa"
import { IVendedor } from "./Vendedor"

export enum VendedorComissaoTipoEnum {
    None = 0,
    Venda = 1,
    Credito = 2,
    Debito = 3,
    Pagamento = 4,
}

export interface IVendedorComissao {
    vendedorComissaoId?: number
    vendedorId: number
    contratoClienteId?: number
    empresaId?: EnumEmpresa
    
    competencia: string
    valor: number
    tipo: IEnumRecord<VendedorComissaoTipoEnum>
    dataHora: Date
    descricao: string

    contratoCliente: IContratoCliente
    vendedor: IVendedor
    empresa: IEmpresa
}

export function useVendedorComissaoTipoColor () {
    const themeColor = useThemeColor();

    const map : KeyOfEnum<VendedorComissaoTipoEnum, string> = React.useMemo(() => ({
        [VendedorComissaoTipoEnum.None]: "",
        [VendedorComissaoTipoEnum.Venda]: themeColor.status.laranja,
        [VendedorComissaoTipoEnum.Credito]: themeColor.status.verde,
        [VendedorComissaoTipoEnum.Debito]: themeColor.status.vermelho,
        [VendedorComissaoTipoEnum.Pagamento]: themeColor.status.azul,
    }), [themeColor.status.azul, themeColor.status.laranja, themeColor.status.verde, themeColor.status.vermelho]);

    return React.useMemo(() => map, [map]);
}

export type IComboVendedorComissaoTipo = ISpecializedCombo<IEnumRecord<VendedorComissaoTipoEnum>>;


export function useVendedorMovimentacaoTipoCombo () : IComboVendedorComissaoTipo {
    const combo = useCombo<IEnumRecord<VendedorComissaoTipoEnum>>();

    const vendedorComissaoService = useVendedorComissaoService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((enumerator, index) => {
            return <MenuItem key={index} value={enumerator.value}>{params?.prefix}{enumerator.description}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback((afterLoad?: AfterLoadEventHandler<IEnumRecord<VendedorComissaoTipoEnum>>) => {
        combo.load(vendedorComissaoService.listarTipos, afterLoad)
    }, [combo, vendedorComissaoService.listarTipos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}
